import ProgressiveCertificationsDataStoreGraphQL from '../datasources/graphql/progressiveCertifications';
import { ProgressiveCertificationsDataStore } from '../datastores/ProgressiveCertificationsDataStore';

export class ProgressiveCertificationsDataStoreFactory {
  static create(): ProgressiveCertificationsDataStore {
    return new ProgressiveCertificationsDataStoreGraphQL();
  }
}
